import 'swiper/css';
import 'swiper/css/scrollbar';
import 'swiper/css/navigation';

import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import MyHead from '../../components/MyHead';
import Image from 'next/future/image';
import VideoPlayer from '@/components/v2/VideoPlayer';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Scrollbar } from 'swiper';
import { XIcon } from '@heroicons/react/solid';
import PopupAreas from '@/components/v2/PopupAreas';

const AreasPage: React.FC = () => {
  const { t } = useTranslation();

  const cards = useMemo(
    () => [
      {
        title: t('P_AREAS.SECTION_SLIDER.CARD-1.TITLE'),
        subtitle: t('P_AREAS.SECTION_SLIDER.CARD-1.SUBTITLE'),
        description: t('P_AREAS.SECTION_SLIDER.CARD-1.DESC'),
        src: '/v2/areas/step1.jpg'
      },
      {
        title: t('P_AREAS.SECTION_SLIDER.CARD-2.TITLE'),
        subtitle: t('P_AREAS.SECTION_SLIDER.CARD-2.SUBTITLE'),
        description: t('P_AREAS.SECTION_SLIDER.CARD-2.DESC'),
        src: '/v2/areas/4-hyper.jpg'
      },
      {
        title: t('P_AREAS.SECTION_SLIDER.CARD-3.TITLE'),
        subtitle: t('P_AREAS.SECTION_SLIDER.CARD-3.SUBTITLE'),
        description: t('P_AREAS.SECTION_SLIDER.CARD-3.DESC'),
        src: '/v2/areas/5-intheartic.jpg'
      },
      {
        title: t('P_AREAS.SECTION_SLIDER.CARD-4.TITLE'),
        subtitle: t('P_AREAS.SECTION_SLIDER.CARD-4.SUBTITLE'),
        description: t('P_AREAS.SECTION_SLIDER.CARD-4.DESC'),
        src: '/v2/areas/6-biotecnology.jpg'
      },
      {
        title: t('P_AREAS.SECTION_SLIDER.CARD-5.TITLE'),
        subtitle: t('P_AREAS.SECTION_SLIDER.CARD-5.SUBTITLE'),
        description: t('P_AREAS.SECTION_SLIDER.CARD-5.DESC'),
        src: '/v2/areas/7-creativity.jpg'
      },
      {
        title: t('P_AREAS.SECTION_SLIDER.CARD-6.TITLE'),
        subtitle: t('P_AREAS.SECTION_SLIDER.CARD-6.SUBTITLE'),
        description: t('P_AREAS.SECTION_SLIDER.CARD-6.DESC'),
        src: '/v2/areas/step6.jpg'
      },
      {
        title: t('P_AREAS.SECTION_SLIDER.CARD-7.TITLE'),
        subtitle: t('P_AREAS.SECTION_SLIDER.CARD-7.SUBTITLE'),
        description: t('P_AREAS.SECTION_SLIDER.CARD-7.DESC'),
        src: '/v2/areas/8-showroom.jpg'
      },
      {
        title: t('P_AREAS.SECTION_SLIDER.CARD-8.TITLE'),
        subtitle: t('P_AREAS.SECTION_SLIDER.CARD-8.SUBTITLE'),
        description: t('P_AREAS.SECTION_SLIDER.CARD-8.DESC'),
        src: '/v2/areas/step8.jpg'
      },
      {
        title: t('P_AREAS.SECTION_SLIDER.CARD-9.TITLE'),
        subtitle: t('P_AREAS.SECTION_SLIDER.CARD-9.SUBTITLE'),
        description: t('P_AREAS.SECTION_SLIDER.CARD-9.DESC'),
        src: '/v2/areas/step9.jpg'
      }
    ],
    []
  );

  return (
    <div>
      <MyHead />

      <div className="section relative full">
        <div className="section-wrapper relative">
          <div className="max-w-[1460px] mx-auto relative">
            <Image
              src="/v2/areas/areasLogo2.png"
              alt=""
              width={0}
              height={0}
              priority
              sizes="100vw"
              className="w-full xl:max-w-[420px] max-w-[200px] mx-auto relative z-30 xl:-mb-8 -mb-3"
            />
            <div className="video-wrapper aspect-landscape w-full relative z-10">
              <VideoPlayer
                src="https://vimeo.com/871003050/9a266560e5"
                autoPlay
              />
            </div>

            <div className="h3 text-center max-w-[860px] mx-auto xl:pt-16 lg:pt-10 pt-6">
              {t('P_AREAS.INTRO.TEXT')}
            </div>
          </div>
        </div>
      </div>

      <div className="section relative full md:aspect-landscapesmall py-32 flex items-center flex-col justify-center bg-gray-300 text-white text-center">
        <Image
          src="/v2/areas/hhBg.jpg"
          alt=""
          width={0}
          height={0}
          priority
          sizes="100vw"
          className="w-full absolute top-0 object-cover object-center h-full left-0 z-10"
        />

        <div className="relative z-30 w-full">
          <div className="h2 max-w-[1240px] mx-auto">
            {t('P_AREAS.BANNER.TITLE')}
          </div>
          <div className="text-3xl uppercase max-w-[720px] mx-auto mt-8">
            {t('P_AREAS.BANNER.TEXT')}
          </div>
          <div className="mt-10">
            <PopupAreas />
          </div>
        </div>
      </div>

      <div className="section relative full">
        <div className="section-wrapper relative">
          <div className="grid gap-8 grid-cols-12">
            <div className="md:col-span-3 col-span-12">
              <div className="text-8xl">
                {t('P_AREAS.SECTION_NUMBERS.NUMBERS.ONE.NUMBER')}
              </div>
              <div className="h3 mt-6">
                {t('P_AREAS.SECTION_NUMBERS.NUMBERS.ONE.TITLE')}
              </div>
              <div className="text-body">
                {t('P_AREAS.SECTION_NUMBERS.NUMBERS.ONE.DESC')}
              </div>
            </div>
            <div className="md:col-span-3 col-span-12">
              <div className="text-8xl">
                {t('P_AREAS.SECTION_NUMBERS.NUMBERS.TWO.NUMBER')}
              </div>
              <div className="h3 mt-6">
                {t('P_AREAS.SECTION_NUMBERS.NUMBERS.TWO.TITLE')}
              </div>
              <div className="text-body">
                {t('P_AREAS.SECTION_NUMBERS.NUMBERS.TWO.DESC')}
              </div>
            </div>
            <div className="md:col-span-3 col-span-12">
              <div className="text-8xl">
                {t('P_AREAS.SECTION_NUMBERS.NUMBERS.THREE.NUMBER')}
              </div>
              <div className="h3 mt-6">
                {t('P_AREAS.SECTION_NUMBERS.NUMBERS.THREE.TITLE')}
              </div>
              <div className="text-body">
                {t('P_AREAS.SECTION_NUMBERS.NUMBERS.THREE.DESC')}
              </div>
            </div>
            <div className="md:col-span-3 col-span-12">
              <div className="text-8xl">
                {t('P_AREAS.SECTION_NUMBERS.NUMBERS.FOUR.NUMBER')}
              </div>
              <div className="h3 mt-6">
                {t('P_AREAS.SECTION_NUMBERS.NUMBERS.FOUR.TITLE')}
              </div>
              <div className="text-body">
                {t('P_AREAS.SECTION_NUMBERS.NUMBERS.FOUR.DESC')}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="section relative full flex items-center flex-col justify-center z-10 bg-gray-400 -mb-40">
        <Image
          src="/v2/areas/ss.jpg"
          alt=""
          width={0}
          height={0}
          sizes="100vw"
          className="w-full absolute top-0 object-cover object-center h-full left-0"
        />
        <div className="section-wrapper relative pt-20 pb-56">
          <div className="grid gap-8 grid-cols-12 md:gap-12 xl:gap-20">
            <div className="col-span-12 text-center text-white">
              <div className="h2 max-w-[900px] mx-auto">
                {t('P_AREAS.SECTION_BOOK.TITLE')}
              </div>
              <div className="text-3xl uppercase max-w-[720px] mx-auto mt-8">
                {t('P_AREAS.SECTION_BOOK.DESC')}
              </div>
              <div className="mt-10">
                <PopupAreas />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="section pt-0 pb-0">
        <div className="section-wrapper">
          <div className="max-w-[1480px] mx-auto grid gap-6 grid-cols-12 md:gap-12 relative z-30">
            <div className="xl:col-span-4 col-span-12 bg-white p-10 aspect-square shadow-xl">
              <div className="h4">{t('P_AREAS.SECTION_BOOK.BOX1TITLE')}</div>
              <div className="text-body mt-10">
                {t('P_AREAS.SECTION_BOOK.BOX1TEXT')}
              </div>
            </div>
            <div className="xl:col-span-4 col-span-12 bg-white p-10 aspect-square shadow-xl">
              <div className="h4">{t('P_AREAS.SECTION_BOOK.BOX2TITLE')}</div>
              <div className="text-body mt-10">
                {t('P_AREAS.SECTION_BOOK.BOX2TEXT')}
              </div>
            </div>
            <div className="xl:col-span-4 col-span-12 bg-white p-10 aspect-square shadow-xl">
              <div className="h4">{t('P_AREAS.SECTION_BOOK.BOX3TITLE')}</div>
              <div className="text-body mt-10">
                <ul className="list-disc pl-4">
                  <li>{t('P_AREAS.SECTION_BOOK.BOX3TEXT1')}</li>
                  <li>{t('P_AREAS.SECTION_BOOK.BOX3TEXT2')}</li>
                  <li>{t('P_AREAS.SECTION_BOOK.BOX3TEXT3')}</li>
                  <li>{t('P_AREAS.SECTION_BOOK.BOX3TEXT4')}</li>
                  <li>{t('P_AREAS.SECTION_BOOK.BOX3TEXT5')}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="section relative full overflow-hidden pt-20">
        <div className="h3 text-center max-w-[860px] mx-auto ">
          {t('P_AREAS.SECTION_SLIDER.TITLE')}
        </div>
        <Swiper
          wrapperTag="ul"
          slidesPerView={1.2}
          spaceBetween={16}
          navigation={true}
          modules={[Scrollbar, Navigation]}
          scrollbar={{ hide: false }}
          className="px-6 md:px-10 xl:px-16 swiperScrollbar xl:pt-16 lg:pt-10 pt-6"
          breakpoints={{
            768: {
              slidesPerView: 2.2
            },
            1024: {
              slidesPerView: 3.4
            }
          }}
        >
          {cards.map((card, idx) => (
            <SwiperSlide key={idx} tag="li" className="">
              <Image
                src={card.src}
                alt=""
                width={0}
                height={0}
                sizes="100vw"
                className="w-full h-auto rounded-uyn"
              />

              <div className="pt-6 pr-3">
                <h3 className="h3">{card.title}</h3>
                <p className="uppercase text-xl mt-2">{card.subtitle}</p>
                <p className="text-body mt-2">{card.description}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      <div className="section relative full overflow-hidden">
        <div className="section-wrapper">
          <div className="grid grid-cols-12 gap-8">
            <div className="text-center mb-10 col-span-12">
              <div className="h3">{t('P_AREAS.SECTION_FINAL.TITLE')}</div>
              <div className="text-body max-w-[960px] mx-auto">
                {t('P_AREAS.SECTION_FINAL.SUBTITLE')}
              </div>
            </div>

            <div className="col-span-12 md:col-span-6 relative md:px-16 md:py-32 p-6 text-center md:rounded-uyn overflow-hidden text-white">
              <Image
                src="/v2/areas/b1.jpg"
                alt=""
                width={0}
                height={0}
                sizes="100vw"
                className="w-full h-full absolute top-0 left-0 object-cover object-center z-10"
              />
              <div className="relative z-20">
                <div className="h3">
                  {t('P_AREAS.SECTION_FINAL.CARD-1.TITLE')}
                </div>
                <div className="text-body mt-4 max-w-[640px]">
                  {t('P_AREAS.SECTION_FINAL.CARD-1.DESC')}
                </div>
                <div className="flex gap-2 flex-wrap mt-8 justify-center">
                  <PopupAreas />
                </div>
              </div>
            </div>

            <div className="col-span-12 md:col-span-6 relative md:px-16 md:py-32 p-6 text-center md:rounded-uyn overflow-hidden text-white">
              <Image
                src="/v2/areas/b2.jpg"
                alt=""
                width={0}
                height={0}
                sizes="100vw"
                className="w-full h-full absolute top-0 left-0 object-cover object-center z-10"
              />
              <div className="relative z-20">
                <div className="h3">
                  {t('P_AREAS.SECTION_FINAL.CARD-2.TITLE')}
                </div>
                <div className="text-body mt-4 max-w-[640px]">
                  {t('P_AREAS.SECTION_FINAL.CARD-2.DESC')}
                </div>
                <div className="flex gap-2 flex-wrap mt-8 justify-center">
                  <PopupAreas />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="section relative full py-32 flex items-center flex-col justify-center bg-gray-300 text-white text-center">
        <Image
          src="/v2/areas/knowledge_is_power.jpg"
          alt=""
          width={0}
          height={0}
          priority
          sizes="100vw"
          className="w-full absolute top-0 object-cover object-center h-full left-0 z-10"
        />

        <div className="relative z-30 w-full">
          <div className="text-3xl uppercase max-w-[720px] mx-auto">
            {t('P_AREAS.BANNER_FINAL.TITLE-1')}
          </div>
          <div className="text-3xl uppercase max-w-[720px] mx-auto">
            {t('P_AREAS.BANNER_FINAL.TITLE-2')}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AreasPage;
